<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Quản lý báo cáo sự cố</div>
      </div>
      <div class="card card-w-title" v-if="display_page">
        <div class="box-top-list">
          <span class="p-m-0 format-title">Chi tiết báo cáo sự cố</span>
          <span class="right-button">
            <Button class="p-button-warning" :label="'Quay lại'" @click="backList" />
          </span>
        </div>
        <div class="box-info p-fluid p-grid">
          <div class="p-col-5">
            <div class="box-info-title">TÀI KHOẢN BÁO CÁO</div>
            <div class="form-info">
              <div class="p-field">
                <label>Tên tài khoản</label>
                <span>{{ obj_data.account_report.fullname }}</span>
              </div>
              <div class="p-field">
                <label>Số điện thoại</label>
                <span>{{obj_data.account_report.phone_number}}</span>
              </div>
              <div class="p-field">
                <label>Quyền truy cập</label>
                <span>{{ (obj_data.account_report.user_type ==1 ) ? 'Khách hàng':obj_data.account_report.role_access}}</span>
              </div>
              <div class="p-field">
                <label>Đơn vị báo cáo</label>
                <span>{{(obj_data.account_report.user_type ==1 )  ? '':obj_data.account_report.reporting_unit}}</span>
              </div>
            </div>
           <div class="box-info-title">THÔNG TIN SẢN PHẨM <span class="info_note">(Thông tin tại thời điểm báo cáo sự cố)</span></div>
            <div class="form-info" >
              <div class="p-field">
                <label>Model sản phẩm</label>
                <div class="box-value" >
                <span>{{obj_data.product.pro_model_code}}</span>
                </div>
              </div>
              <div class="p-field">
                <label>Tên sản phẩm</label>
                <div class="box-value" >
                <span>{{obj_data.product.pro_name}}</span>
                </div>
              </div>
              <div class="p-field">
                <label>Serial number</label>
                <div class="box-value" >
                <span>{{obj_data.product.serial_number}}</span> <a style="font-family:'Arial Italic', 'Arial';font-style:italic;" :href="obj_data.product.link_serial_number">(Xem chi tiết)</a>
                </div>
              </div>
              <div class="p-field">
                <label>Nhóm sản phẩm</label>
                <span>{{obj_data.product.pro_group}}</span>
              </div>
              <div class="p-field">
                <label>Trạng thái bảo hành</label>
                <div class="box-status"  :style="obj_data.product.status_item.style" >
                  <div class="style-text-status">
                    {{obj_data.product.status_item.name}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="p-col-5 p-offset-1" >
            <div class="box-info-title">NỘI DUNG BÁO CÁO</div>
            <div class="form-info">
              <div class="p-field">
                <label>Trạng thái xử lý</label>
                <div class="box-status" :style="obj_data.content_report.status_item.style" >
                  <div class="style-text-status">
                    {{obj_data.content_report.status_item.name}}
                  </div>
                </div>
              </div>
              <div class="p-field">
                <label>Thời gian báo cáo</label>
                <span>{{obj_data.content_report.created_at}}</span>
              </div>
              <div class="p-field">
                <label>Loại sự cố</label>
                <div class="box-value" >
                  <span>{{obj_data.content_report.type_violate}}</span>
                </div>
                <!--<span>{{obj_data.content_report.type_violate}}</span>-->
              </div>
              <div class="p-field">
                <label>Lý do chi tiết</label>
                <div class="box-value" >
                  <span>{{obj_data.content_report.detailed_reason}}</span>
                </div>
              </div>
            </div>
            <div class="box-info-title">{{ (obj_data.content_report.status_item.value == 0) ? 'XỬ LÝ BÁO CÁO SỰ CỐ':'THÔNG TIN XỬ LÝ'}}</div>
            <div class="form-info" v-if="obj_data.content_report.status_item.value == 0">
              <Textarea v-model="valueProcessReport" :autoResize="true" rows="6" cols="30" @keyup="changeProcessReport" />
              <p class="message_err" :style="(is_error == true) ? '':'display: none;'" >Nhập nội dung xử lý</p>
              <div class="box-button" v-if="$myConstants.checkRoleGroup('report_violation', 'action_report')">
                  <Button label="Hoàn thành" class="p-button-success btn-done" @click="showConfirmDone"  />
                  <Button label="Báo cáo sai" class="p-button-warning btn-false-report" @click="showConfirmFalseReport"/>
              </div>
            </div>
            <div class="form-info" v-else>
              <div class="p-field">
                <label>Thời gian cập nhật</label>
                <div class="box-value" >
                  <span>{{ obj_data.info_process.date_update }}</span>
                </div>
              </div>
              <div class="p-field">
                <label>Người cập nhật</label>
                <div class="box-value" >
                  <span>{{ obj_data.info_process.user_update }}</span>
                </div>
              </div>
              <div class="p-field">
                <label>Đơn vị cập nhật</label>
                <div class="box-value" >
                  <span>{{ obj_data.info_process.unit_update }}</span>
                </div>
              </div>
              <div class="p-field">
                <label>Nội dung xử lý</label>
                <div class="box-value" >
                  <span>{{ obj_data.info_process.content }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Dialog

        class="dialog-comfirm-report"
        :visible.sync="showConfirmDialog"
        :contentStyle="{overflow: 'visible'}"
        :modal="true"
        :closable="false"
    >
       c<!--Gán nội dung => sau đó ẩn vì ko có nội dung dialog ko mở lên được-->
      <template #header>
        <div>
          <span class="title-confirm" >Xác nhận</span>
          <span class="description-confirm">{{contentConfirm}}</span>
        </div>
      </template>
      <template
          #footer
      >
        <div class="box-comfirm-button">
          <div class="btn-confirm-yes" @click="acceptConfirm"><span>Đồng ý</span></div>
          <div class="btn-confirm-no" @click="showConfirmDialog = false"><span>Không</span></div>
        </div>
      </template>
    </Dialog>

  </div>
</template>

<script>
import moment from "moment-timezone";
import DataServices from '@/core/DataServices'
import Api from '@/services'
export default {
  components: {
  },
  data() {
    return {
      files: [],
      listData: [],
      dataModel: null,
      listDataLog: [],
      dataModelLog: null,
      componentKey: Math.random()*100,
      componentKeyLog: Math.random()*560,
      showRejectDialog: false,
      showAcceptDialog: false,
      reasonTypes: [],
      reasonItem: {},
      obj_data:{
        account_report:{
          fullname:'',
          phone_number:'',
          role_access:'',
          reporting_unit:'',
          user_type:1,
        },
        content_report:{
          status_item:{
            value:0,
            name:'Chờ xử lý',
            style:'background-color: rgba(153, 0, 204, 1);',
          },
          status_name:'',
          created_at:'',
          type_violate:'',
          detailed_reason:'',
          status_list:[
            {
              value:0,
              name:'Chờ xử lý',
              style:'background-color: rgba(153, 0, 204, 1);',
            },
            {
              value:1,
              name:'Hoàn thành',
              style:'background-color: rgba(0, 0, 204, 1);',
            },
            {
              value:2,
              name:'Báo cáo sai',
              style:'background-color: rgba(102, 102, 102, 1);',
            }
          ]
        },
        product:{
          pro_model_code:'',
          pro_name:'',
          link_serial_number:'#',
          serial_number:'',
          pro_group:'',//nhóm sp
          status_item:{ value: 0, name: 'Chưa kích hoạt', style: 'background-color: #FF6600;'},
          status_list:[
            { value: 0, name: 'Chưa kích hoạt', style: 'background-color: rgba(255, 102, 0, 1);'},
            { value: 2, name: 'Chờ kích hoạt', style: 'background-color: rgb(153, 0, 204);'},
            { value: 3, name: 'Đã kích hoạt', style: 'background-color: rgb(0, 204, 0);'},
            { value: 4, name: 'Hết bảo hành', style: 'background-color: rgb(51, 0, 204);'},
            { value: 6, name: 'Sản phẩm huỷ', style: 'background-color: rgb(0, 0, 0);'}]
            //{ value: 6, name: 'Sản phẩm huỷ', style: 'background-color: #0000;'}]
        },/*#020202*/
        info_process:{
          date_update:'',
          user_update:'',
          unit_update:'',
          content:'',
        }
      },
      lstProducts: [],
      submitCheck: false,
      date_verify: moment(new Date()).format('DD/MM/YYYY'),
      reason_verify: '',
      status: 0,
      submitAccept: false,
      id: 0,
      changed_serial_number_id: '',
      serial_number_id: 0,
      reason_note: '',
      submitReject: false,
      errorReject: -1,
      errorReasonNote: '',
      isInvoice: false,
      componentAcceptKey: Math.random()*2389,
      componentRejectKey: Math.random()*1209,
      organizationID: 0,
      acceptance_images: [],
      acceptance_images_string: [],
      enableButton: false,
      dynamicForms: [],
      showConfirmDialog: false,
      valueProcessReport:'',
      contentConfirm:'',
      is_error:false,
      type_confirm:1,//1.Hoàn thành,2.Báo cáo sai
      display_page:true
    }
  },
  async mounted () {
    var vm =this;
    //this.showConfirmDialog = true;
   // console.log('this.showConfirmDialog',this.showConfirmDialog)
    if (this.$route.params.id !== undefined && !isNaN(this.$route.params.id)) {
      if (!vm.$myConstants.checkRoleGroup('report_violation', 'view')){
        vm.display_page = false;
        return false;
      }
      this.id = Number(this.$route.params.id);
      this.initData();
    }
  },
  methods: {
    initData() {
      setTimeout(async () => {
        if (this.checkVisible('report_violation', 'view')) {
          await this.initParams();
        }
      }, 1000);
    },
    checkVisible(groupName, action) {
      return this.$myConstants.checkVisible(this.$store.getters.permission, groupName, action);
    },
    async initParams() {
      this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      await this.getSetting();
      await this.getData(this.id);
     // await this.getDataProduct(this.id);
      //await this.getDataLog(this.id);
      //await this.getDynamicForm(this.id);
      this.$store.commit('setLoading', false);
    },
    async getSetting() {
      var variables = {
        where_key: {
          key: {'_eq': 'REQUIRED_UPLOAD_IMAGE_CONTRACT'}
        }
      }
      var data = await DataServices.getList('settings', {"variables": JSON.stringify(variables), "fields": "value"});
      var list = data[Object.keys(data)];
      if (list != undefined && list != null && list.length > 0) {
        this.isInvoice = (list[0].value == 'true');
      }
    },
    async settingReasonReject() {
      var variables = {
        where_key: {
          status: {'_in': [1] },
          reason_type: {'_eq': 'not_accepted'}
        },
        orderBy: {
          ordering: 'asc'
        }
      }
      var data = await DataServices.getList('setting_reason_reject', {"variables": JSON.stringify(variables), "fields": "id code reason_name  reason_type is_add_note is_change_product"});
      var list = data[Object.keys(data)];
      if (list != undefined && list != null) {
        for (let index = 0; index < list.length; index++) {
          const ele = list[index];
          this.reasonTypes.push({name: ele.reason_name , value: ele.id, is_add_note: ele.is_add_note, is_change_product: ele.is_change_product, code: ele.code, reason_type: ele.reason_type});
        }
      }
    },
    changeInput($event) {
      var date = new Date($event);
      var dateNow = new Date();
      if (dateNow < date) this.date_verify = moment(dateNow).format('DD/MM/YYYY');
      else this.date_verify = moment(date).format('DD/MM/YYYY');
    },
    async getData(id) {
      var modelName = 'report_violation';
      var variables = {
        where_key: {
          id: {'_eq': id }
        }
      }
      var data = await DataServices.getList(modelName, {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      
      if (list != undefined && list != null && Object.keys(list).length > 0) {
        var records = list[0];
        if (!this.$myConstants.isEmpty(records.users)){
          var data_user = records.users;
          this.obj_data.account_report.fullname = (data_user.full_name) ? data_user.full_name:'';
          this.obj_data.account_report.phone_number = (data_user.phone_number) ? data_user.phone_number.replace('+84', '0'):'';
          var role_access = (data_user.user_role) ? ((data_user.user_role.roles) ? data_user.user_role.roles.name:''):'';
          this.obj_data.account_report.role_access = role_access;
          var reporting_unit = (data_user.organization_account) ? ((data_user.organization_account.organization) ? data_user.organization_account.organization.name:''):'';
          this.obj_data.account_report.reporting_unit = reporting_unit;
          this.obj_data.account_report.user_type = (data_user.user_type) ? data_user.user_type:1;
        }
        var status = records.status;
        var status_list = this.obj_data.content_report.status_list;
        for (var i=0;i<status_list.length;i++){
          if (parseFloat(status) == parseFloat(status_list[i].value)){
            this.obj_data.content_report.status_item = status_list[i];
            break;
          }
        }
        if (status != 0){
          //show dữ liệu thông ting xử lý
          this.obj_data.info_process.date_update = moment.tz(records.modified_date, this.$myConstants.timeZone()).format('DD/MM/YYYY HH:mm');
          this.obj_data.info_process.content = (!this.$myConstants.isEmpty(records.processed_note)) ? records.processed_note:'';
          if (!this.$myConstants.isEmpty(records.modifier)){
            var data_modifier = records.modifier;
            this.obj_data.info_process.user_update = (data_modifier.full_name) ? data_modifier.full_name:'';
            var unit_update = (data_modifier.organization_account) ? ((data_modifier.organization_account.organization) ? data_modifier.organization_account.organization.name:''):'';
            this.obj_data.info_process.unit_update = unit_update;
          }
        }
        if (!this.$myConstants.isEmpty(records.created_at)){
          this.obj_data.content_report.created_at = moment.tz(records.created_at, this.$myConstants.timeZone()).format('DD/MM/YYYY HH:mm');
        }
        this.obj_data.content_report.type_violate = (!this.$myConstants.isEmpty(records.type_violation)) ? records.type_violation.name  :  '';
        this.obj_data.content_report.detailed_reason = (!this.$myConstants.isEmpty(records.note)) ? records.note  :  '';
        if (!this.$myConstants.isEmpty(records.product_info)){
          var product = JSON.parse(records.product_info);
          this.obj_data.product.serial_number = (!this.$myConstants.isEmpty(product.serial_number)) ? product.serial_number:'';
          this.obj_data.product.link_serial_number = (!this.$myConstants.isEmpty(product.id)) ? '/admin/serial-number/view-detail/'+product.id:'#';
          if ((!this.$myConstants.isEmpty(product.product))){
            this.obj_data.product.pro_model_code = (!this.$myConstants.isEmpty(product.product.model_code)) ? product.product.model_code:'';
            this.obj_data.product.pro_name = (!this.$myConstants.isEmpty(product.product.name)) ? product.product.name:'';
            //Nhóm sp
            var group_product = (!this.$myConstants.isEmpty(product.product.categories)) ? ((!this.$myConstants.isEmpty(product.product.categories.name)) ? product.product.categories.name:''):'';
            this.obj_data.product.pro_group = group_product;
            //lấy trạng thái bảo hành
            var warrantyStatus = 0;
            if ((!this.$myConstants.isEmpty(product.product_serial_number_info)) && (!this.$myConstants.isEmpty(product.product_serial_number_info.status)) && parseInt(product.product_serial_number_info.status) == 1) warrantyStatus = (product.product_serial_number_info.warranty_status == 5 ? 0 : product.product_serial_number_info.warranty_status);
            else warrantyStatus = (product.warranty_status == 5 ? 0 : product.warranty_status);
            var war_status_list = this.obj_data.product.status_list;
            for (var j=0;j<war_status_list.length;j++){
              if (parseFloat(warrantyStatus) == parseFloat(war_status_list[j].value)){
                this.obj_data.product.status_item = war_status_list[j];
                break;
              }
            }
          }

        }
       /*
        product:{
          pro_model_code:'',
              pro_name:'',
              serial_number:'',
              pro_group:'',//nhóm sp
              status_name:'',
        }
      },*/

      }
    },
    async getDataProduct(id) {
      var name = 'request_activation_product_serial';
      var variables = {
        where_key: {
          request_activation_id: {'_eq': id },
          status: {'_eq': 1}
        }
      }
      var data = await DataServices.getList(name, {"variables": JSON.stringify(variables), "fields": "id serial_number_id activation_date verify_status warranty_status product_serial_number { id serial_number product { model_code name warranty_time warranty_unit } warranty_status product_serial_number_info { customer_profile_id organization_id warranty_status verify_status warranty_time warranty_unit } }"});
      var list = data[Object.keys(data)];
      this.dataModel = DataServices.getModel(name);
      this.dataModel.processData(list);
      this.listData = list;
      this.enableButton = false;     
      if(this.checkVisible('warranty_activation', 'accepted')) {
        var returnAllow = this.listData.filter(a => a.verify_status == 0);
        if (returnAllow && Object.keys(returnAllow).length) this.enableButton = true;
      }
      this.componentKey = Math.random()*100;
    },
    async getDataLog(id) {
      var nameLog = 'request_activation_changed_log';
      var variables = {
        where_key: {
          request_activation_id: {'_eq': id},
          status: {'_in': [0, 1]}
        },
        orderBy: {
          id: 'desc'
        }
      }
      var data = await DataServices.getList(nameLog, {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      this.dataModelLog = DataServices.getModel(nameLog);
      this.dataModelLog.processData(list);
      this.listDataLog = list;
      this.componentKeyLog = Math.random()*10;
    },
    async getDynamicForm(id) {
      this.dynamicForms = [];
      var nameDynamic = 'product_serial_number_dynamic_form';
      var variables = {
        where_key: {
          request_activation_id: {'_eq': id},
          status: {'_eq': 1}
        }
      }
      var data = await DataServices.getList(nameDynamic, {"variables": JSON.stringify(variables), "fields": "serial_number_id data_dynamic_form"});
      var list = data[Object.keys(data)];
      if (list && list != null && Array.isArray(list) && list.length) {
        var dataDynamic = list[0];
        if (dataDynamic.data_dynamic_form !== undefined && dataDynamic.data_dynamic_form != null && Object.keys(dataDynamic.data_dynamic_form).length) {
          var forms = JSON.parse(dataDynamic.data_dynamic_form);
          if (forms && forms != null && Array.isArray(forms) && forms.length) {
            for (let index = 0; index < forms.length; index++) {
              const item = forms[index];
              if (item && item.fields && item.fields != null && Object.keys(item.fields).length) {
                var dynamicName = item.fields.name;
                var dynamicValue = item.fields.value;
                if (item.fields.backend_type == 'date' && item.fields.validation != undefined && item.fields.validation != null) {
                  var validation =  JSON.parse(item.fields.validation);
                  if (dynamicValue != null && validation.date && validation.date.format != undefined && validation.date.format != '') {
                    dynamicValue = moment(dynamicValue).format(validation.date.format);
                  }
                }
                this.dynamicForms.push({name: dynamicName, value: dynamicValue});
              }
            }
          }
        }
      }
    },
    getRowActions() {
      var actions = {}
      var that = this;
      actions.rows = function (rowData) {
        var buttons = {}
        buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `/admin/warranty-activation/view-detail`}
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      switch (action.name) {
        case 'edit':
          this.$router.push(action.path + '/' + data.data[action.key])
          break;
      }
    },
    backList() {
       this.$router.push({path: '/admin/report-violation'});
    },
    changeReason() {
      this.submitReject = false;
    },
    
    async checkSeiralNumber(serialNumber) {
      this.errorReject = -1;
      var returnData = this.lstProducts.filter(a => a.serial_number == serialNumber);
      if (returnData && Object.keys(returnData).length) {
        this.errorReject = 1;
        this.errorReasonNote = 'Vui lòng chọn sản phẩm thay thế';
      }
      else {
        var variables = {
          where_key: {
            product_serial_number: {
              serial_number: {'_eq': serialNumber },
              production_status: {'_eq': 1},
              status: {'_eq': 1}
            },
            status: {'_eq': 1}
          }
        }
        var data = await DataServices.getList('product_serial_number_info', {"variables": JSON.stringify(variables), "fields": "serial_number_id product_id product_serial_number { serial_number  } products { model_code } warranty_status verify_status"});
        var list = data[Object.keys(data)];
        if (list != null && list.length > 0) {
          var dataSerial = list[0];
          this.changed_serial_number_new_id = dataSerial.serial_number_id;
          var serialNumberCode = dataSerial.products.model_code;
          var modelData = this.lstProducts.filter(a => a.model_code == serialNumberCode);
          if (modelData && modelData.length) {
            if (dataSerial.warranty_status == 1 || dataSerial.warranty_status == 3 || dataSerial.warranty_status == 4) {
              this.errorReject = 1;
              this.errorReasonNote = 'Serial number đã kích hoạt bảo hành. Vui lòng nhập lại serial number';
            } else if (dataSerial.warranty_status == 2) {
              this.errorReject = 1;
              this.errorReasonNote = 'Serial number đang chờ kích hoạt bảo hành.Vui lòng nhập lại serial number';
            } else {
              this.errorReject = 0;
              this.errorReasonNote = '';
            }
          } else {
            this.errorReject  = 1;
            this.errorReasonNote = 'Vui lòng đổi sản phẩm mới cùng mã sản phẩm cũ';
          }
        } else {
          var variables1 = {
            where_key: {
              serial_number: {'_eq': serialNumber },
              production_status: {'_eq': 1},
              status: {'_eq': 1}
            }
          }
          var data1 = await DataServices.getList('product_serial_number', {"variables": JSON.stringify(variables1), "fields": "id serial_number warranty_status product { model_code }"});
          var list1 = data1[Object.keys(data1)];
          if (list1 != null && list1.length > 0) {
            var dataSerial1 = list1[0];
            if (dataSerial1.warranty_status == 1 || dataSerial1.warranty_status == 3) {
              this.errorReject = 1;
              this.errorReasonNote = 'Serial number đã kích hoạt bảo hành. Vui lòng nhập lại serial number';
            } else if (dataSerial1.warranty_status == 2) {
              this.errorReject = 1;
              this.errorReasonNote = 'Serial number đang chờ kích hoạt bảo hành.Vui lòng nhập lại serial number';
            } else {
              var serialNumberModelCode = dataSerial1.product.model_code;
              var modelSerial = this.lstProducts.filter(a => a.model_code == serialNumberModelCode);
              if (modelSerial && modelSerial.length) {
                this.errorReject = 0;
                this.changed_serial_number_new_id = dataSerial1.id;
              } else {
                this.errorReject = 1;
                this.errorReasonNote = 'Vui lòng nhập mã serial cùng model với sản phẩm cũ'; 
              }
            }
          } else  {
            this.errorReject = 1;
            this.errorReasonNote = 'Vui lòng chọn sản phẩm thay thế';
          }
        }
      }
    },
    async acceptReject() {
      this.$store.commit('setDataLoading', {content: 'Đang kiểm dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      this.errorReject = -1;
      this.submitReject = true;
      if (this.reasonItem == undefined || this.reasonItem == null || Object.keys(this.reasonItem).length == 0) {
        this.errorReject = 1;
      }
      else {
        this.reason_note = this.reason_note.trim();
        if (this.reasonItem.is_add_note && (this.reason_note == '' || this.reason_note.length == 0)) {
          this.errorReject = 1;
        } else if (this.reasonItem.is_change_product && (this.changed_serial_number_id == '' || this.changed_serial_number_id.length == 0)) {
          this.errorReject = 1;
          this.errorReasonNote = 'Vui lòng chọn sản phẩm thay thế';
        } else this.errorReject = 0;
      }
      if (this.changed_serial_number_id != '') {
        // console.log('ffffffffffffffffffff')
        // check seriral co trong he thong khong
        await this.checkSeiralNumber(this.changed_serial_number_id);
      }
      // if (this.changed_serial_number_id != '' && (this.changed_serial_number_new_id == '' || this.changed_serial_number_new_id == null)) {
      //   this.errorReject = 1;
      //   this.errorReasonNote = 'Vui lòng đổi sản phẩm mới cùng mã sản phẩm cũ';
      //   console.log('tttt');
      //   // console.log('ttttttttttt', this.changed_serial_number_id, this.changed_serial_number_new_id, this.errorReasonNote)
      // }
      // console.log('aaaaaaaaaaaaaaaaa', this.errorReject);
      if (this.submitReject && this.errorReject == 0 && this.lstProducts.length > 0) {
        // console.log('dddddddddđ');
        this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
        this.$store.commit('setLoading', true);
        var vm = this;
        var k = 0;
        // console.log('ddddddđ', vm.lstProducts);
        while (k < vm.lstProducts.length) {
          await vm.processReject(vm.lstProducts[k], k);
          if (k == (vm.lstProducts.length - 1)) {
            await vm.checkProcessAllProduct();
            this.$store.commit('setLoading', false);
            vm.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000 })
            vm.showRejectDialog = false;
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
          k++;
        }
      } else this.$store.commit('setLoading', false);
    },
    async checkProcessAllProduct() {
      var dataAll = await DataServices.getList('request_activation_product_serial', {"variables": JSON.stringify({ where_key: { request_activation_id: {'_eq': this.id }, verify_status: {'_eq': 0} } }), "fields": "id"});
      var listAll = dataAll[Object.keys(dataAll)];
      if (listAll == null || (listAll != null && listAll.length == 0)) {
        var status = (this.changed_serial_number_id != '' && this.changed_serial_number_new_id != '') ? 0 : 1; 
        await DataServices.updateData('request_activation', {"variables": JSON.stringify({data_update: {process_status: 1, status: status}, where_key: {id: {'_eq': this.id}}})});
      }
    },
    async processReject(info, index) {
      var customerID = 0;
      var organizationID = 0;
      var organizationUser = (this.$store.getters.fullname != undefined && this.$store.getters.fullname != null &&
      this.$store.getters.fullname.organization_account != undefined && this.$store.getters.fullname.organization_account != null
      && this.$store.getters.fullname.organization_account.organization_id != undefined && 
      this.$store.getters.fullname.organization_account.organization_id != null) ? this.$store.getters.fullname.organization_account.organization_id: 0;

      organizationID = (info.product_serial_number != undefined && info.product_serial_number != null && info.product_serial_number.product_serial_number_info != undefined && info.product_serial_number.product_serial_number_info != null) ? info.product_serial_number.product_serial_number_info.organization_id : 0;
      customerID = (info.product_serial_number != undefined && info.product_serial_number != null && info.product_serial_number.product_serial_number_info != undefined && info.product_serial_number.product_serial_number_info != null) ? info.product_serial_number.product_serial_number_info.customer_profile_id : 0;
      
      // cập nhật trạng thái không nghiệm thu cho request_activation_product_serial
      var whereKey = { request_activation_id: {'_eq': this.id }, serial_number_id: {'_eq': info.serial_number_id } }
      var paramsUpdate = { modified_date: this.$myConstants.currentDate(), verify_status: 2,  warranty_status: 0}
      await DataServices.updateData('request_activation_product_serial', {"variables": JSON.stringify({data_update: paramsUpdate, where_key: whereKey})});
      
      
      // tạo log request_activation_changed_log
     
      var rowActivationChangeLog = {}, oldValue = {}, newValue = {};
      var dataActivation = await DataServices.getList('request_activation', {"variables": JSON.stringify({ where_key: { id : {'_eq': this.id } } })});
      var listActivation = dataActivation[Object.keys(dataActivation)];
      if (listActivation != null && listActivation.length > 0) {
        oldValue = listActivation[0];
        // organizationID = (oldValue['organization_id'] != undefined && oldValue['organization_id'] != null) ? oldValue['organization_id'] : 0;
        newValue = oldValue;
      }
     
      if (index == 0) {
        var message = 'Không nghiệm thu '+ this.lstProducts.length + ' sản phẩm';
        if (this.changed_serial_number_id != '' && this.changed_serial_number_id.length > 0) {
          message = 'Không nghiệm thu '+ this.lstProducts.length + ' sản phẩm. Đổi serial number mới: ' + this.changed_serial_number_id;
        }
        newValue['message'] = message;

        rowActivationChangeLog = Object.assign(rowActivationChangeLog, { 'request_activation_id': this.id });
        rowActivationChangeLog = Object.assign(rowActivationChangeLog, { 'modifier_id': this.$store.getters.fullname.id });
        rowActivationChangeLog = Object.assign(rowActivationChangeLog, { 'organization_id':  organizationUser });
        rowActivationChangeLog = Object.assign(rowActivationChangeLog, { 'message': message });
        rowActivationChangeLog = Object.assign(rowActivationChangeLog, { 'created_date': this.$myConstants.currentDate() });
        rowActivationChangeLog = Object.assign(rowActivationChangeLog, { 'modified_date': this.$myConstants.currentDate() });
        if (oldValue && Object.keys(oldValue).length > 0) rowActivationChangeLog = Object.assign(rowActivationChangeLog, { 'old_value': JSON.stringify(oldValue) });
        if (newValue && Object.keys(newValue).length > 0) rowActivationChangeLog = Object.assign(rowActivationChangeLog, { 'new_value': JSON.stringify(newValue) });

        await DataServices.insertData('request_activation_changed_log', {"variables": JSON.stringify({objects: rowActivationChangeLog})});
      }

      var oldSerialInfo = {}, newSerialInfo = {};
      var warrantyStatus = 0;
      // kiểm tra xem đã có kích hoạt trước đó chưa
      var dataWarranty = await DataServices.getList('product_serial_number_info', {"variables": JSON.stringify({ where_key: { serial_number_id: {'_eq': info.serial_number_id } } }), "fields": "serial_number_id product_id request_activation_id product_serial_number { serial_number warranty_status production_status production_order_code product_id status product { warranty_time warranty_unit returnable_time returnable_unit change_time change_unit is_manually_verification}} customer_profile_id organization_id model_code name description thumbnail_id warranty_time warranty_unit is_returnable returnable_time  returnable_unit change_time change_unit last_modifier is_manually_verification created_date modified_date qr_code_size category_id date_of_sale activation_date status  warranty_status verify_status invoice_images acceptance_images data_dynamic_form"});
      var listWarranty = dataWarranty[Object.keys(dataWarranty)];
      // tắt kích hoạt nếu đã kích hoạt thành công trước đó
      if (listWarranty != null && Object.keys(listWarranty).length > 0) {
        oldSerialInfo = listWarranty[0];
        newSerialInfo = oldSerialInfo;
        warrantyStatus = (oldSerialInfo.warranty_status != null && (oldSerialInfo.warranty_status == 1 || oldSerialInfo.warranty_status == 3) ? 5 : 0);
      }

      var paramsInfo = {};
      paramsInfo = Object.assign(paramsInfo,  {request_activation_id: this.id});
      paramsInfo = Object.assign(paramsInfo,  {modified_date: this.$myConstants.currentDate()});
      paramsInfo = Object.assign(paramsInfo,  {verify_status: 2});
      paramsInfo = Object.assign(paramsInfo,  {warranty_status: warrantyStatus});
      await DataServices.updateData('product_serial_number_info', {"variables": JSON.stringify({data_update: paramsInfo, where_key: { serial_number_id: {'_eq': info.serial_number_id } }})});
      

      newSerialInfo['warranty_status'] = warrantyStatus;
      newSerialInfo['verify_status'] = 2;
      newSerialInfo['message'] = this.reasonItem.name;
      if (this.changed_serial_number_id != '') {
        newSerialInfo['message']+= '.Serial number mới ' + this.changed_serial_number_id;
      }
      if (this.reason_note != '') {
        newSerialInfo['message']+= '. ' + this.reason_note;
      }

      newSerialInfo['organization_id'] = organizationUser;
      

      var rowSerialChangeLog = {};
      rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'request_activation_id': this.id })
      rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'serial_number_id': info.serial_number_id })
      rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'modifier_id': this.$store.getters.fullname.id })
      rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'old_value': JSON.stringify(oldSerialInfo) })
      rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'new_value': JSON.stringify(newSerialInfo) })
      rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'created_date': this.$myConstants.currentDate() })
      rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'modified_date': this.$myConstants.currentDate() })
      await DataServices.insertData('product_serial_number_info_log_changed', {"variables": JSON.stringify({objects: rowSerialChangeLog})});
      

      var paramsStatusChange = {}
      paramsStatusChange = Object.assign(paramsStatusChange, { 'request_activation_id': this.id })
      paramsStatusChange = Object.assign(paramsStatusChange, { 'serial_number_id': info.serial_number_id })
      paramsStatusChange = Object.assign(paramsStatusChange, { 'old_warranty_status': info.warranty_status })
      paramsStatusChange = Object.assign(paramsStatusChange, { 'old_verify_status': info.verify_status})
      paramsStatusChange = Object.assign(paramsStatusChange, { 'new_warranty_status': warrantyStatus})
      paramsStatusChange = Object.assign(paramsStatusChange, { 'new_verify_status': 2 })
      paramsStatusChange = Object.assign(paramsStatusChange, { 'modifier_id': this.$store.getters.fullname.id })
      paramsStatusChange = Object.assign(paramsStatusChange, { 'customer_profile_id': customerID })
      paramsStatusChange = Object.assign(paramsStatusChange, { 'organization_id': organizationID })
      paramsStatusChange = Object.assign(paramsStatusChange, { 'reason_type': this.reasonItem.reason_type })
      paramsStatusChange = Object.assign(paramsStatusChange, { 'reason_code': this.reasonItem.code })
      paramsStatusChange = Object.assign(paramsStatusChange, { 'source': 'web' })
      if (this.reason_note.length > 0) paramsStatusChange = Object.assign(paramsStatusChange, { 'note': this.reason_note })
      if (this.changed_serial_number_id.length > 0) paramsStatusChange = Object.assign(paramsStatusChange, { 'changed_serial_number_id': this.changed_serial_number_new_id })
      paramsStatusChange = Object.assign(paramsStatusChange, { 'created_date': this.$myConstants.currentDate() })
      await DataServices.insertData('product_serial_number_info_status_changed', {"variables": JSON.stringify({objects: paramsStatusChange})});
      
      // // đổi sản phẩm khác
      if (this.changed_serial_number_id != '' && this.changed_serial_number_new_id != '') {
        // console.log('vao day')
        this.createProductInfoToRequest(customerID, organizationID, info.serial_number);
      }
      // this.showRejectDialog = false;
    },
    async createProductInfoToRequest(customerID, organizationID, serial_number) {
      var organizationUser = (this.$store.getters.fullname != undefined && this.$store.getters.fullname != null &&
      this.$store.getters.fullname.organization_account != undefined && this.$store.getters.fullname.organization_account != null
      && this.$store.getters.fullname.organization_account.organization_id != undefined && 
      this.$store.getters.fullname.organization_account.organization_id != null) ? this.$store.getters.fullname.organization_account.organization_id: 0;

      var dataNewProductSerial = {};
      dataNewProductSerial['request_activation_id'] = this.id;
      dataNewProductSerial['serial_number_id'] = this.changed_serial_number_new_id;
      dataNewProductSerial['created_date'] =  this.$myConstants.currentDate();
      dataNewProductSerial['modified_date'] =  this.$myConstants.currentDate();
      dataNewProductSerial['user_id'] =  this.$store.getters.fullname.id;
      dataNewProductSerial['activation_date'] =  this.$myConstants.currentDate();
      dataNewProductSerial['warranty_status'] = 2;
      dataNewProductSerial['verify_status'] = 0;
      dataNewProductSerial['status'] = 1;
      var dataProductSerial = await DataServices.getList('request_activation_product_serial', {"variables": JSON.stringify({ where_key: { serial_number_id: {'_eq': this.changed_serial_number_new_id }, request_activation_id: {'_eq': this.id } } }), "fields": "serial_number_id request_activation_id"});
      dataProductSerial = dataProductSerial[Object.keys(dataProductSerial)];
      if (dataProductSerial != null && Object.keys(dataProductSerial).length > 0) {
        await DataServices.updateData('request_activation_product_serial', {"variables": JSON.stringify({data_update: dataNewProductSerial, where_key: {serial_number_id: {'_eq': this.changed_serial_number_new_id }, request_activation_id: {'_eq': this.id }}})});  
      } else {
        // console.log('dataNewProductSerial', dataNewProductSerial)
        await DataServices.insertData('request_activation_product_serial', {"variables": JSON.stringify({objects: dataNewProductSerial})});
      }

      var newValue = {};
      var dataSerialInfo = await DataServices.getList('product_serial_number_info', {"variables": JSON.stringify({ where_key: { serial_number_id: {'_eq': this.changed_serial_number_new_id }, status: {'_eq': 1} } }), "fields": "serial_number_id product_id request_activation_id product_serial_number { serial_number warranty_status production_status production_order_code product_id status product { warranty_time warranty_unit returnable_time returnable_unit is_manually_verification}} customer_profile_id organization_id model_code name description thumbnail_id warranty_time warranty_unit is_returnable returnable_time  returnable_unit last_modifier is_manually_verification created_date modified_date qr_code_size category_id date_of_sale activation_date status  warranty_status verify_status invoice_images acceptance_images data_dynamic_form"});
      dataSerialInfo = dataSerialInfo[Object.keys(dataSerialInfo)];
      if (dataSerialInfo != null && Object.keys(dataSerialInfo).length > 0) {
        newValue = dataSerialInfo[0];
        var dataNewSerialInfo = {
          request_activation_id: this.id,
          modified_date: this.$myConstants.currentDate(),
          verify_status: 0,
          warranty_status: 2
        }
        await DataServices.updateData('product_serial_number_info', {"variables": JSON.stringify({data_update: dataNewSerialInfo, where_key: { serial_number_id: {'_eq': this.changed_serial_number_new_id }}})});
      } else {
        var dataNewSerialInfoChange = {
          serial_number_id: this.changed_serial_number_new_id,
          customer_profile_id: customerID,
          organization_id: organizationID,
          request_activation_id: this.id,
          warranty_status: 2,
          verify_status: 0,
          status: 1,
          created_date: this.$myConstants.currentDate(),
          modified_date: this.$myConstants.currentDate()
        };
        var variablesProduct = {where_key: { product_serial_number: { id: {'_eq': this.changed_serial_number_new_id }, status: {'_eq': 1} }, production_status: {'_eq': 1}, status: {'_eq': 1} } }
        var dataProduct = await DataServices.getList('product', {"variables": JSON.stringify(variablesProduct), "fields": "id model_code name description thumbnail_id warranty_time warranty_unit is_returnable returnable_time returnable_unit change_time change_unit last_modifier is_manually_verification qr_code_size category_id"});
        var listProduct = dataProduct[Object.keys(dataProduct)];
        if (listProduct != null && listProduct.length > 0) {
          var rowProduct = listProduct[0];
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {product_id: rowProduct.id});
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {model_code: rowProduct.model_code});
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {name: rowProduct.name});
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {description: rowProduct.description});
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {thumbnail_id: rowProduct.thumbnail_id});
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {warranty_time: rowProduct.warranty_time});
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {warranty_unit: rowProduct.warranty_unit });
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {is_returnable: rowProduct.is_returnable });
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {returnable_time: rowProduct.returnable_time });
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {returnable_unit: rowProduct.returnable_unit });
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {change_time: rowProduct.change_time });
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {change_unit: rowProduct.change_unit });
           
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {last_modifier: rowProduct.last_modifier });
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {is_manually_verification: rowProduct.is_manually_verification });
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {qr_code_size: rowProduct.qr_code_size });
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {category_id: rowProduct.category_id });
         

        }

        newValue = dataNewSerialInfoChange;
        
        // newValue['request_activation'] = {id: this.id}
        // console.log('dnewValue', newValue)
        await DataServices.insertData('product_serial_number_info', {"variables": JSON.stringify({objects: dataNewSerialInfoChange})});
        
      }
      newValue['warranty_status'] = 2;
      newValue['verify_status'] = 0;
      newValue['organization_id'] = organizationUser;
      newValue['request_activation'] = {id: this.id};
      newValue['invoice_images'] = this.invoiceImagesTmp;
      newValue['message'] = 'Gửi yêu cầu kích hoạt bảo hành thay thế Serial number ' + serial_number; 
      // thêm product_serial_number_info_log_changed
      var dataNewChangeLog = {};
      dataNewChangeLog = Object.assign(dataNewChangeLog, { 'request_activation_id': this.id })
      dataNewChangeLog = Object.assign(dataNewChangeLog, { 'serial_number_id': this.changed_serial_number_new_id})
      dataNewChangeLog = Object.assign(dataNewChangeLog, { 'modifier_id': this.$store.getters.fullname.id })
      dataNewChangeLog = Object.assign(dataNewChangeLog, { 'new_value': JSON.stringify(newValue) })
      dataNewChangeLog = Object.assign(dataNewChangeLog, { 'created_date': this.$myConstants.currentDate() })
      dataNewChangeLog = Object.assign(dataNewChangeLog, { 'modified_date': this.$myConstants.currentDate() })
      await DataServices.insertData('product_serial_number_info_log_changed', {"variables": JSON.stringify({objects: dataNewChangeLog})});

      

      var dataNewStatusChange = {
        request_activation_id: this.id,
        serial_number_id: this.changed_serial_number_new_id, 
        new_warranty_status: 2,
        new_verify_status: 0,
        modifier_id: this.$store.getters.fullname.id,
        customer_profile_id: customerID,
        organization_id: organizationUser,
        modified_date: this.$myConstants.currentDate(),
        source: 'web'
      }

      await DataServices.insertData('product_serial_number_info_status_changed', {"variables": JSON.stringify({objects: dataNewStatusChange})});
     
    },
    async acceptAction() {
      this.submitAccept = true;
      var isProccess = false;
      if (this.isInvoice &&  this.files.length > 0)  isProccess = true;
      if (!this.isInvoice) isProccess = true;
      

      if (this.lstProducts.length > 0 && this.date_verify != '' && isProccess) {
        this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
        this.$store.commit('setLoading', true);
        var vm = this;
        var checkUpload = true;
        var k = 0;
        if ( this.files.length > 0) {
          checkUpload = await this.uploadImages();  
        }
        if ( checkUpload) {
          while (k < vm.lstProducts.length) {
            await vm.processAccept(vm.lstProducts[k]);
            if (k == (vm.lstProducts.length - 1)) {
              await vm.updateActivationChangedAccept();
            }
            k++;
          }
        }
      }
    },
    async processAccept(info) {
      // console.log('sdfds', this.acceptance_images, info)
      var params = {}
      var customerID = 0;
      var organizationUser = (this.$store.getters.fullname != undefined && this.$store.getters.fullname != null &&
      this.$store.getters.fullname.organization_account != undefined && this.$store.getters.fullname.organization_account != null
      && this.$store.getters.fullname.organization_account.organization_id != undefined && 
      this.$store.getters.fullname.organization_account.organization_id != null) ? this.$store.getters.fullname.organization_account.organization_id: 0;

      this.organizationID = (info.product_serial_number != undefined && info.product_serial_number != null && info.product_serial_number.product_serial_number_info != undefined && info.product_serial_number.product_serial_number_info != null) ? info.product_serial_number.product_serial_number_info.organization_id : 0;
      customerID = (info.product_serial_number != undefined && info.product_serial_number != null && info.product_serial_number.product_serial_number_info != undefined && info.product_serial_number.product_serial_number_info != null) ? info.product_serial_number.product_serial_number_info.customer_profile_id : 0;

      params = Object.assign(params, { 'request_activation_id': this.id })
      params = Object.assign(params, { 'serial_number_id': info.serial_number_id })
      params = Object.assign(params, { 'old_warranty_status': info.warranty_status })
      params = Object.assign(params, { 'old_verify_status': info.verify_status})
      params = Object.assign(params, { 'new_warranty_status': 3})
      params = Object.assign(params, { 'new_verify_status': 1 })
      params = Object.assign(params, { 'modifier_id': this.$store.getters.fullname.id })
      params = Object.assign(params, { 'customer_profile_id': customerID})
      params = Object.assign(params, { 'organization_id': organizationUser })

      if (this.reason_note.length > 0) params = Object.assign(params, { 'note': 'Nghiệm thu sản phẩm ' + this.reason_verify })
      params = Object.assign(params, { 'source': 'web' })

      var paramsUpdate = { modified_date: this.$myConstants.currentDate(), verify_status: 1, warranty_status: 3 }

      var dateActive = this.$myConstants.currentDate();
      if(this.date_verify != null && this.date_verify != '') {
        var dateNow = new Date();
        const [d, M, y] = this.date_verify.match(/\d+/g);
        var changeDate = new Date(y, M-1, d, dateNow.getHours(), dateNow.getMinutes(), dateNow.getSeconds());
        paramsUpdate = Object.assign(paramsUpdate,  {activation_date: changeDate.toUTCString()})
        params = Object.assign(params, { created_date: changeDate.toUTCString() })
        dateActive = this.$myConstants.currentDate(changeDate.toUTCString());
      }

    
      await DataServices.insertData('product_serial_number_info_status_changed', {"variables": JSON.stringify({objects: params})});
     
      var whereKey = { request_activation_id: {'_eq': this.id }, serial_number_id: {'_eq': info.serial_number_id } }
      

     
      await DataServices.updateData('request_activation_product_serial', {"variables": JSON.stringify({data_update: paramsUpdate, where_key: whereKey})});

      var variablesSerial = {
        where_key: {
          serial_number_id: {'_eq': info.serial_number_id },
          status: {'_eq': 1}
        }
      }
      var dataSerial = await DataServices.getList('product_serial_number_info', {"variables": JSON.stringify(variablesSerial), "fields": "serial_number_id product_id request_activation_id customer_profile_id organization_id model_code name description thumbnail_id warranty_time warranty_unit is_returnable returnable_time  returnable_unit change_time change_unit is_manually_verification last_modifier is_manually_verification created_date modified_date qr_code_size category_id date_of_sale activation_date status  warranty_status verify_status invoice_images acceptance_images data_dynamic_form product_serial_number { serial_number warranty_status production_status production_order_code product_id status product { warranty_time warranty_unit returnable_time returnable_unit change_time change_unit is_manually_verification } }"});
      var listSerial = dataSerial[Object.keys(dataSerial)];
      if (listSerial != null && listSerial.length > 0) {
        var rowSerial = listSerial[0];
        var rowSerialNew = rowSerial;
        rowSerialNew['verify_status'] = 1;
        rowSerialNew['activation_date'] = dateActive;
        rowSerialNew['warranty_status'] = 3;
        rowSerialNew['modified_date'] = this.$myConstants.currentDate();
        var message = 'Nghiệm thu sản phẩm'
        if (this.reason_verify.length > 0) {
          message += '. ' + this.reason_verify;
        }
        rowSerialNew['message'] = message;


        var whereInfo = { serial_number_id: {'_eq': info.serial_number_id } }
        var paramsInfo = { modified_date: this.$myConstants.currentDate(), verify_status: 1, warranty_status: 3 }

        if(this.date_verify != null && this.date_verify != '') {
          var dateNowInfo = new Date();
          const [d, M, y] = this.date_verify.match(/\d+/g);
          var changeDateNew = new Date(y, M-1, d, dateNowInfo.getHours(), dateNowInfo.getMinutes(), dateNowInfo.getSeconds());
          paramsInfo = Object.assign(paramsInfo,  {activation_date: changeDateNew.toUTCString()})
        }
        
        rowSerialNew['acceptance_images'] = JSON.stringify(this.acceptance_images);
        rowSerialNew['organization_id'] = organizationUser;
       
        await DataServices.updateData('product_serial_number_info', {"variables": JSON.stringify({data_update: paramsInfo, where_key: whereInfo})});


        // console.log('dfdfgfd', rowSerialNew);

        var paramsInfoLog = {serial_number_id: info.serial_number_id, old_value: JSON.stringify(rowSerial), new_value: JSON.stringify(rowSerialNew), created_date: this.$myConstants.currentDate(), modified_date: this.$myConstants.currentDate(), modifier_id: this.$store.getters.fullname.id }
        // console.log('paramsInfoLog', paramsInfoLog);

        paramsInfoLog = Object.assign(paramsInfoLog, { 'request_activation_id': this.id })
       
        await DataServices.insertData('product_serial_number_info_log_changed', {"variables": JSON.stringify({objects: paramsInfoLog})});


        await DataServices.updateData('product_serial_number_info', {"variables": JSON.stringify({data_update: {acceptance_images:  JSON.stringify(this.acceptance_images)}, where_key: whereInfo})});

      }
    },
    async uploadImages() {
      var countUpload = 0;
      if (this.files.length > 0) {
        var k = 0;
        var vm = this;
        while (k < vm.files.length) {
          var isUpload = await vm.uploadOneImages(k);
          if (isUpload) {
            k++;
            countUpload++;
          }
        }
      } else countUpload = 1;
      return countUpload > 0;
    },
    async uploadOneImages(k) {
      var vm = this;
      var returnData = '';
      var file = vm.files[k];
      let formData = new FormData();
      formData.append('file', file);
      await Api.post('/common/upload-s3', formData)
      .then((response) => {
        var obj = response.data.data;
        obj.path = obj.url;
        vm.acceptance_images.push(obj);
        vm.acceptance_images_string.push(response.data.data.url);
        returnData = response.data.data.url;
      })
      .catch((err) => {returnData = JSON.stringify(err)});
      return returnData.length > 0;
    },
    async updateActivationChangedAccept () {
      var organizationUser = (this.$store.getters.fullname != undefined && this.$store.getters.fullname != null &&
      this.$store.getters.fullname.organization_account != undefined && this.$store.getters.fullname.organization_account != null
      && this.$store.getters.fullname.organization_account.organization_id != undefined && 
      this.$store.getters.fullname.organization_account.organization_id != null) ? this.$store.getters.fullname.organization_account.organization_id: 0;

      var variablesActivationChanged = {
        where_key: {
          request_activation_id: {'_eq': this.id },
          status: {'_eq': 1}
        },
        orderBy: {
          id: 'desc'
        },
        limit: 1
      }
      var oldValue = null;
      var dataActivationChanged = await DataServices.getList('request_activation_changed_log', {"variables": JSON.stringify(variablesActivationChanged), "fields": "id request_activation_id modifier_id organization_id message created_date modified_date status"});
      if(dataActivationChanged != null) {
        var listActivationChanged = dataActivationChanged[Object.keys(dataActivationChanged)];
        if (listActivationChanged != null && listActivationChanged.length > 0) {
          oldValue = listActivationChanged[0];
        }
      }
      var newValue = oldValue;
      var message = 'Nghiệm thu ' + this.lstProducts.length + ' sản phẩm';
      if (newValue != null) newValue['message'] = message;
      else newValue = { message: message}
      var paramsActivationLog = {};
      paramsActivationLog = Object.assign(paramsActivationLog, { 'request_activation_id': this.id });
      paramsActivationLog = Object.assign(paramsActivationLog, { 'modifier_id': this.$store.getters.fullname.id });
      paramsActivationLog = Object.assign(paramsActivationLog, { 'organization_id': organizationUser });
      paramsActivationLog = Object.assign(paramsActivationLog, { 'message': message });
      paramsActivationLog = Object.assign(paramsActivationLog, { 'old_value': JSON.stringify(oldValue) });
      paramsActivationLog = Object.assign(paramsActivationLog, { 'new_value': JSON.stringify(newValue) });
      paramsActivationLog = Object.assign(paramsActivationLog, { 'created_date': this.$myConstants.currentDate() });
      paramsActivationLog = Object.assign(paramsActivationLog, { 'modified_date': this.$myConstants.currentDate() });
      paramsActivationLog = Object.assign(paramsActivationLog, { 'status': 1 });
      
      await DataServices.insertData('request_activation_changed_log', {"variables": JSON.stringify({objects: paramsActivationLog})});
      
      var dataUpdateActivation = {}

      var dataProductSerial = await DataServices.getList('request_activation_product_serial', {"variables": JSON.stringify({where_key: {
        request_activation_id: {'_eq': this.id },
        verify_status: {'_eq': 0},
        status: {'_eq': 1}
      }}), "fields": "id" });

      var listProductSerial = dataProductSerial[Object.keys(dataProductSerial)];
      if (listProductSerial == null || (listProductSerial != null && listProductSerial.length == 0)) {
        dataUpdateActivation = Object.assign(dataUpdateActivation, {process_status: 1, status: 1})
      }

      if (Array.isArray(this.acceptance_images)) {
        dataUpdateActivation  = Object.assign(dataUpdateActivation, {acceptance_images: JSON.stringify(this.acceptance_images)});
      }
      if (dataUpdateActivation && Object.keys(dataUpdateActivation).length) {
        await DataServices.updateData('request_activation', {"variables": JSON.stringify({data_update: dataUpdateActivation, where_key: {id: {'_eq': this.id}}})});
      }

      this.$store.commit('setLoading', false);
      this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000 })
      this.showAcceptDialog = false;
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    },
    closeAccept() {
      this.showAcceptDialog = false;
      this.submitCheck = false;
    },
    async acceptVerify() {
      this.submitCheck = true;
      var listPro = this.lstProducts.filter(a => a.verify_status == 0);
      if (this.lstProducts.length > 0 && listPro && Object.keys(listPro).length) {
        var lstSerialID = this.lstProducts.map(function(item) {return item.serial_number_id});
        var variablesSerial = {
          where_key: {
            serial_number_id : {'_in': lstSerialID },
            verify_status: {'_neq': 0},
            status: {'_eq': 1}
          }
        }
        var dataInfo = await DataServices.getList('product_serial_number_info', {"variables": JSON.stringify(variablesSerial), "fields": "serial_number_id "});
        if (dataInfo != null &&  dataInfo[Object.keys(dataInfo)].length) {
          this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Danh sách có sản phẩm không hợp lệ. Một số sản phẩm trong danh sách đã được nghiệm thu/kích hoạt bảo hành, vui lòng kiểm tra lại trước khi tiếp tục', life: 3000 });
        } else {
          this.showAcceptDialog = false;
          if (this.lstProducts.length > 0) {
            this.componentAcceptKey = Math.random()*2389;
            this.showAcceptDialog = true;
          }
        }
      }
    },
    async rejectVerify() {
      this.componentRejectKey = Math.random()*1209;
      this.reasonItem = {};
      this.changed_serial_number_id = '';
      this.reason_note = '';
      this.submitCheck = true;
      this.submitReject = false;
      var listPro = this.lstProducts.filter(a => a.verify_status == 0);
      if (this.lstProducts.length > 0 && listPro && Object.keys(listPro).length) {
        var lstSerialID = this.lstProducts.map(function(item) {return item.serial_number_id});
        var variablesSerial = {
          where_key: {
            serial_number_id : {'_in': lstSerialID },
            verify_status: {'_neq': 0},
            status: {'_eq': 1}
          }
        }
        var dataInfo = await DataServices.getList('product_serial_number_info', {"variables": JSON.stringify(variablesSerial), "fields": "serial_number_id "});
        if (dataInfo != null &&  dataInfo[Object.keys(dataInfo)].length) {
          this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Danh sách có sản phẩm không hợp lệ. Một số sản phẩm trong danh sách đã được nghiệm thu/kích hoạt bảo hành, vui lòng kiểm tra lại trước khi tiếp tục', life: 3000 });
        } else {
          this.showRejectDialog = true;
          this.reasonTypes = [];
          await this.settingReasonReject();
        }
      }
    },
    closeReject () {
      this.showRejectDialog = false;
      this.submitCheck = false;
    },
    openFile() {
      this.$refs.files.click();
    },
    chooseFile($event) {
      $event.preventDefault();
      $event.stopPropagation();
      var checkFile = false;
      var arrFiles = [];
      var fileSelects = $event.target.files || $event.dataTransfer.files;
      if (!fileSelects.length)
        return;
      for (let index = 0; index < fileSelects.length; index++) {
        const file = fileSelects[index];
        if (this.$myConstants.isImage(file.type)) {
          file.source = file;
          file.src = window.URL.createObjectURL(file);
          file.objectURL = window.URL.createObjectURL(file);
          arrFiles.push(file);
        } else {
          checkFile = true;
          break;
        }
      }
      if (checkFile) {
        this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Sai định dạng file', life: 3000 })
      } else {
        this.files = this.files.concat.apply(this.files, arrFiles);
      }
    },
    removeImg(index) {
      this.files.splice(index, 1);
      if (this.files.length == 0) this.files = [];
    },
    onRowSelectedAll(data) {
      this.lstProducts = data;
    },
    onRowSelected(data) {
      this.lstProducts = data;
    },
    setIndex(index) {
      this.indexInvoice = index
    },
    setIndexUpload(index) {
      this.indexUpload = index
    },
    acceptConfirm(){
      var that = this;
      this.$store.commit('setLoading', true);
      var dataUpdate = {
        processed_note:this.valueProcessReport,
        status:parseFloat(this.type_confirm),
        modifier_id:this.$store.getters.fullname.id,
        modified_date:this.$myConstants.currentDate()
      }
      DataServices.updateData('report_violation', {"variables": JSON.stringify({data_update: dataUpdate, where_key: {id: {'_eq': this.id}}})}).then(async () => {
        that.showConfirmDialog = false;
        that.$store.commit('setLoading', false);
        that.$router.go();//reload
      }).catch(async () => {
        alert('Đã có lỗi xảy ra, Vui lòng thử lại!');
        this.$store.commit('setLoading', false);
      });
    },
    changeProcessReport(){
      var valueProcessReport = (this.valueProcessReport) ? this.valueProcessReport.trim():'';
      if (this.$myConstants.isEmpty(valueProcessReport)){
        this.is_error = true;
        return false;
      }
      this.is_error = false;
    }
    ,
    showConfirmDone(){
      if ((!this.validateConfirm())){
        return false;
      }
      this.contentConfirm = 'Bạn đồng ý xác nhận đã xử lý xong báo cáo sự cố này?';
      this.showConfirmDialog = true;
      this.type_confirm = 1;
    },
    showConfirmFalseReport(){
      if ((!this.validateConfirm())){
        return false;
      }
      this.contentConfirm = 'Bạn đồng ý xác nhận không xử lý xong báo cáo sự cố này?';
      this.showConfirmDialog = true;
      this.type_confirm = 2;
    },
    validateConfirm(){
      var valueProcessReport = (this.valueProcessReport) ? this.valueProcessReport.trim():'';
      if (this.$myConstants.isEmpty(valueProcessReport)){
        this.is_error = true;
        return false;
      }
      this.is_error = false;
      return true;
    }
  }
}
</script>
<style lang="scss">
.box-top-list{ margin-bottom: 0px;
  &.last-changed{margin-bottom: 15px;}
  span{font-size: 20; text-align: left; }
  .right-button{float: right;}
  .format-title{font-weight: bold; font-size: 25px;}
}
.box-info{ padding: 0 20px;
  &.list-product{margin-bottom: 30px;}
  .box-info-title{ font-size: 16px; font-weight: 700; margin-bottom: 10px; margin-top: 20px;
  .info_note{
    font-size: 13px!important;
    font-family: 'Arial Italic', 'Arial';
    font-weight: 400;
    font-style: italic;
  }
  }
  .box-invoice-img{
    img{margin-right: 20px;
      &:last-child{margin: 0;}
    }
  }
  .form-info{
    .message_err{
      text-align: right!important;font-weight: 400; font-style: italic; color: #FF0000; font-size: 14px;margin-bottom: 0px
    }
    .p-field{ padding: 10px;
      &:nth-child(n) {background: #E4E4E4;}
      &:nth-child(2n) {background: #fff;}
      label{ width: 200px; margin: 0;}
      .box-status{
        position: relative;
        background-color: rgba(153, 0, 204, 1);
        border-radius: 5px;
        text-align: center;
        //midle vertical
        display: inline-block;
        vertical-align: middle;
        padding-left: 9px;
        padding-right: 10px;
        padding-top: 2px;
        padding-bottom: 2px;
        .style-text-status{
          font-family: 'Arial Bold', 'Arial';
          font-weight: 700;
          font-style: normal;
          font-size: 14px;
          color: #FFFFFF;
        }
      }
    .box-value{
      width: calc(100% - 220px);//căn chỉnh để xuống thẳng hàng
      display: inline-block;
    }
    }
    .box-button{
      margin-top: 10px;
      .btn-done{
        width: 120px;
        float: left;
        margin-right: 32px;
        background: linear-gradient(180deg, rgba(66, 139, 202, 1) 0%, rgba(66, 139, 202, 1) 0%, rgba(45, 108, 162, 1) 100%, rgba(45, 108, 162, 1) 100%) !important;
        border: 1px solid #428bca;
        font-family: 'Arial Bold', 'Arial';
        font-weight: 700;
        font-style: normal;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 24px;
      }
      .btn-false-report{
        width: 120px;
        background: linear-gradient(180deg, rgb(240, 173, 78) 0%, rgba(240, 173, 78, 1) 0%, rgba(235, 147, 22, 1) 100%, rgba(235, 147, 22, 1) 100%);
        border: 1px solid #F0AD4E;
        font-family: 'Arial Bold', 'Arial';
        font-weight: 700;
        font-style: normal;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 24px;
      }
    }
  }
  &.log-changed{
    .p-datatable {
      .p-datatable-thead{
        tr {
          th {background: #169BD5;
            .p-column-title{color: #fff;}
          }
        }
      }
      .p-datatable-tbody{
        tr {
          td {
            &:last-child{text-align: left !important;}
          }
        }
      }
    }
  }
  .btn-function {margin-top: 15px;
    button{width: 170px; margin-right: 15px;}
  }
}
.dialog-reject{overflow: visible;
  .dialog-content{padding: 0 30px;
    p{font-size: 16px; margin: 0;}
  }
  .p-dialog-footer{text-align: center; border: 0 none; padding-bottom: 20px;
    button{width: 150px; margin-right: 15px; text-transform: uppercase;
      &:last-child{margin-right: 0;}
    }
  }
}
.custom-error{display: block; color: #f00; margin-top: 10px;}
.box-list-img{ margin: 0;
  .images-wrapper {
    .item-img {margin-bottom: 10px;
      .item{position: relative; text-align: center; width: 100px; margin: 0 auto;
        .remove-icon{cursor: pointer; position: absolute; right: -7px; top: -8px; color: #fff; background: #f00; width: 15px; height: 15px; overflow: hidden; border-radius: 50%;
          span{color: #fff; font-size: 8px; position: relative;top: -7.5px; left: 0px; font-weight: bold;}
        }
        .img {padding-top: 6px;
          img{max-width: 100%; height: auto;}
        }
      }
    }
  }
}
.images-wrapper { display: flex;
  .image {height: 150px; width: 100px; display: block; margin-right: 20px; cursor: pointer; background-size: cover;
    &:last-child{margin: 0;}
  }
}
.dialog-comfirm-report{
  .p-dialog-header{
    border-bottom:unset;
    .title-confirm{
      display: block;text-align: center;font-family: 'Arial Bold', 'Arial'; font-weight: 700 !important;font-size: 16px !important;margin-top: 8px;margin-bottom: 8px;
    }
    .description-confirm{
      text-align: center;font-family: 'Arial'; font-weight: 400 !important;font-size: 16px!important;padding-left: 16px;padding-right: 16px;
    }
  }
  .p-dialog-content{
    display: none;
  }
  .p-dialog-footer{
    padding: 0px;
    .box-comfirm-button{
      width: 100%;
      .btn-confirm-yes{

        width: 50%;height: 48px;float: left;border-right: 1px solid #c8c8c8;
        //Canh center
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        span{
          font-family: 'Arial';
          font-weight: 400;
          font-style: normal;
          font-size: 16px;
        }
      }
      .btn-confirm-no{
        text-align: center;
        width: 50%;height: 48px;float: right;
        //Canh center
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        span{
          font-family: 'Arial';
          font-weight: 400;
          font-style: normal;
          font-size: 16px;
        }
      }
    }
  }
}
</style>